import { useNavigate } from "react-router-dom";

const Error = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="hero min-h-screen bg-base-100">
      <div className="hero-content flex-col lg:flex-row">
        <img
          src="/illustration.png"
          alt="THE MAKER Illustration"
          className="max-w-sm rounded-lg"
        />
        <div className="text-center lg:text-left">
          <h1 className="text-5xl font-bold text-center lg:text-left">
            {children}
          </h1>
          <p className="py-6 text-center lg:text-left">
            하단의 버튼을 눌러 페이지를 이동할 수 있습니다.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => {
              navigate(-1);
              window.close();
            }}
          >
            나가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error;
